// Scoped styles for the tour (everything under .bmt).
export const TOUR_CSS = `
.bmt { background: var(--bm-paper-alt); position: relative; }
.bmt-wide { max-width: 1340px; margin: 0 auto; padding-left: 16px; padding-right: 16px; }
@media (min-width: 768px) { .bmt-wide { padding-left: 32px; padding-right: 32px; } }

/* hotspot */
.bmt-ring { position: absolute; inset: -5px; border: 2px solid #8FD53A; pointer-events: none; z-index: 5; animation: bmt-pulse 1.7s var(--bm-ease) infinite; }
@keyframes bmt-pulse {
  0% { box-shadow: 0 0 0 0 rgba(143,213,58,.6); }
  70% { box-shadow: 0 0 0 14px rgba(143,213,58,0); }
  100% { box-shadow: 0 0 0 0 rgba(143,213,58,0); }
}
.bmt-hit { position: absolute; inset: -5px; z-index: 6; cursor: pointer; background: transparent; border: 0; }
.bmt-hit:hover ~ .bmt-tip { background: #181343; }
.bmt-tip { position: absolute; z-index: 7; left: 50%; white-space: nowrap; background: #241E61; color: #fff; font-size: 11px; font-weight: 600; line-height: 1; padding: 7px 11px; border-radius: 999px; pointer-events: none; box-shadow: 0 8px 18px -8px rgba(24,19,67,.6); animation: bmt-tipin .28s var(--bm-ease) .2s both; }
.bmt-tip::after { content: ''; position: absolute; left: 50%; width: 8px; height: 8px; background: inherit; transform: translateX(-50%) rotate(45deg); }
.bmt-tip-top { bottom: calc(100% + 13px); transform: translateX(-50%); }
.bmt-tip-top::after { bottom: -3px; }
.bmt-tip-bottom { top: calc(100% + 13px); transform: translateX(-50%); }
.bmt-tip-bottom::after { top: -3px; }
@keyframes bmt-tipin { from { opacity: 0; margin-top: 4px; } to { opacity: 1; margin-top: 0; } }

/* screens */
.bmt-screen { animation: bmt-in .24s var(--bm-ease) both; }
@keyframes bmt-in { from { transform: translateX(16px); opacity: .25; } to { transform: none; opacity: 1; } }
.bmt-switch { animation: bmt-switch 2.8s var(--bm-ease) .15s both; }
@keyframes bmt-switch {
  0% { transform: translateY(-10px); opacity: 0; }
  8%, 82% { transform: none; opacity: 1; }
  100% { transform: translateY(-6px); opacity: 0; }
}
.bmt-notify { animation: bmt-drop .32s var(--bm-ease) both; }
@keyframes bmt-drop { from { transform: translateY(-24px); opacity: 0; } to { transform: none; opacity: 1; } }
.bmt-sheet { animation: bmt-up .3s var(--bm-ease) both; }
@keyframes bmt-up { from { transform: translateY(100%); } to { transform: none; } }
.bmt-rowin { animation: bmt-rowin .5s var(--bm-ease) both; }
@keyframes bmt-rowin { from { transform: translateY(-10px); opacity: 0; } to { transform: none; opacity: 1; } }
.bmt-flash { animation: bmt-flash 1.4s var(--bm-ease) both; border-radius: 4px; }
@keyframes bmt-flash { from { background: rgba(143,213,58,.35); } to { background: transparent; } }
.bmt-dot { animation: bmt-blink 1.1s ease-in-out infinite; }
@keyframes bmt-blink { 50% { opacity: .25; } }
.bmt-scanline { position: absolute; left: 10px; right: 10px; height: 2px; top: 12%; background: #8FD53A; box-shadow: 0 0 12px 2px rgba(143,213,58,.7); animation: bmt-scan .8s var(--bm-ease) both; }
@keyframes bmt-scan { to { top: 88%; } }
.bmt-sigdraw { stroke-dashoffset: 1; animation: bmt-sig .9s var(--bm-ease) .05s forwards; }
@keyframes bmt-sig { to { stroke-dashoffset: 0; } }
.bmt-typing i { width: 6px; height: 6px; border-radius: 50%; background: #9A9C9A; animation: bmt-bounce 1s infinite; }
.bmt-typing i:nth-child(2) { animation-delay: .15s; }
.bmt-typing i:nth-child(3) { animation-delay: .3s; }
@keyframes bmt-bounce { 0%, 60%, 100% { transform: none; } 30% { transform: translateY(-3px); } }

/* surfaces */
.bmt-surface { transition: opacity .25s var(--bm-ease), filter .25s var(--bm-ease); }
.bmt-surface.is-dim { opacity: .5; filter: saturate(.6); }
.bmt-surface.is-dim:hover { opacity: .8; }
.bmt-cap { font-size: 12px; color: var(--bm-muted); align-items: center; gap: 8px; height: 22px; margin-bottom: 10px; white-space: nowrap; }
.bmt-cap b { color: var(--bm-indigo); font-weight: 600; }
.bmt-cap .bmt-live { width: 7px; height: 7px; border-radius: 50%; background: #3FAE6C; }
@media (max-width: 1023px) {
  .bmt-stage[data-view="phone"] .bmt-admin, .bmt-stage[data-view="admin"] .bmt-phone { display: none; }
  .bmt-surface.is-dim { opacity: 1; filter: none; }
}

/* progress */
.bmt-seg { height: 4px; border-radius: 4px; background: #E4E3F0; flex: 1; position: relative; overflow: hidden; cursor: pointer; border: 0; padding: 0; }
.bmt-seg::after { content: ''; position: absolute; inset: 0; background: var(--bm-gradient); transform: scaleX(0); transform-origin: left; transition: transform .35s var(--bm-ease); }
.bmt-seg.is-done::after, .bmt-seg.is-now::after { transform: scaleX(1); }
.bmt-seg.is-now { box-shadow: 0 0 0 1.5px #241E61; }
.bmt-seg:focus-visible { outline: 2px solid var(--bm-emerald); outline-offset: 3px; }
.bmt-seghit { padding: 10px 0; flex: 1; display: flex; cursor: pointer; background: none; border: 0; }

/* the step card */
.bmt-card { background: #241E61; color: #fff; border-radius: 22px; box-shadow: 0 30px 60px -30px rgba(24,19,67,.6); }
@media (max-width: 1023px) {
  .bmt-card { position: fixed; left: 8px; right: 8px; bottom: max(8px, env(safe-area-inset-bottom)); z-index: 45; border-radius: 20px; }
  .bmt-why { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
}
.bmt-card .chip { background: rgba(255,255,255,.08); color: rgba(255,255,255,.8); box-shadow: inset 0 0 0 1px rgba(255,255,255,.14); }
.bmt-card .chip-live { color: #CFF710; }
.bmt-key { display: inline-grid; place-items: center; min-width: 20px; height: 20px; padding: 0 5px; border-radius: 5px; font-size: 11px; background: rgba(255,255,255,.1); box-shadow: inset 0 -1px 0 rgba(255,255,255,.15); }

/* intro choices */
.bmt-choice { display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 4px 16px; width: 100%; text-align: left; padding: 18px 20px; border-radius: 18px; background: #fff; box-shadow: inset 0 0 0 1px var(--bm-line); transition: box-shadow .18s var(--bm-ease), transform .18s var(--bm-ease); cursor: pointer; }
.bmt-choice:hover { box-shadow: inset 0 0 0 1.5px var(--bm-indigo), 0 14px 30px -20px rgba(36,30,97,.45); }
.bmt-choice:hover .bmt-arrow { background: var(--bm-indigo); color: #fff; }
.bmt-arrow { grid-row: span 2; width: 40px; height: 40px; border-radius: 50%; display: grid; place-items: center; color: var(--bm-indigo); box-shadow: inset 0 0 0 1.5px var(--bm-line); transition: background .18s var(--bm-ease), color .18s var(--bm-ease); }

.bmt-recap li button { width: 100%; text-align: left; }
`;
